module.exports = __webpack_public_path__ + "static/media/cifar2.f8549a14.png";